import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import { INDICES, QUERY_DEFAULTS } from '@/shared/api/openmetadata';

import type { ServiceSearchResponse } from './types';

export const fetchDataServices = async (): Promise<ServiceSearchResponse> => {
  const response = await openMetadataApiClient.get<ServiceSearchResponse>(`/search/query`, {
    params: {
      q: QUERY_DEFAULTS.Q,
      index: INDICES.DATA_ASSET,
      from: 0,
      size: 0,
      deleted: QUERY_DEFAULTS.DELETED,
      track_total_hits: true,
      fetch_source: false,
    },
  });

  return response.data;
};
